import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { WidgetInput } from "react-addressfinder";
import "react-addressfinder/dist/widget.css";
import { DropdownDate, } from 'react-dropdown-date';

const ConnectionForm = ({ buy, vispID, address, onSuccess, onActiveSuccess }) => {

  const SERVER_URL = process.env.REACT_APP_API_URL;
  const [apiMessage, setApiMessage] = useState([]);
  const [apiStatus, setApiStatusCode] = useState('');
  const [apiCalled, setApiCalled] = useState(false);
  const [isAsap, setIsAsap] = useState(false);
  const [checkAsServiceAddress, setCheckAsServiceAddress] = useState(false);
  const [haveFinderValue, setHaveFinderValue] = useState(false);
  const [minDate, setMinDate] = useState('');

  const [formData, setFormData] = useState({
    inputAddress: address,
    fixedRequestedConnectionDate: new Date(),
    delivery_address: '',
    visp_qualification_id: vispID,
    fixedOrderAs: '',
    as_soon_as_possible: isAsap,
    customer_id: '12',
    person_accepting_delivery: '',
    customer_company_name: ''
  });



  const today = new Date();
  const currentYear = today.getFullYear();
  //const endDate = `${currentYear + 5}-12-31`;

  const [date, setDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState(today);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });
  };


  const setMinimumDate = () => {
    const today = new Date().toISOString().split('T')[0];
    setMinDate(today);
  };

  const handleAddressFinderChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value
    });
    setHaveFinderValue(true)
  };

  const AddressFinderComponent = ({ addressFinderKey, inputClassName, id, onChange }) => {
    const handleSelectedAddress = (fullAddress, searchAddress) => {
      onChange('delivery_address', fullAddress);
    };

    return (
      <WidgetInput
        addressFinderKey={addressFinderKey}
        inputClassName={inputClassName}
        id={id}
        onSelected={handleSelectedAddress}
      />
    );
  };

  const handleASAP = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {

      setIsAsap(true)
      setFormData({
        ...formData,
        as_soon_as_possible: true
      });

    } else {

      setIsAsap(false)
    }

  }
  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(`${SERVER_URL}nbn_customer_connection_details`, formData, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(response => {
        setApiStatusCode(response.data.status);
        setApiMessage(response.data.message);
        setApiCalled(true);
        setTimeout(() => {

          setApiCalled(false);
          onSuccess(e); // Pass data to onSuccess
          onActiveSuccess();
        }, 2000);
      })
      .catch(error => {

        setApiCalled(true);
        setApiStatusCode(false);

        const errorMessage = error.response.data.message;
        setApiMessage(errorMessage);
      })
      .finally(() => {
        setTimeout(() => {
          setApiCalled(false);
        }, 10000);
      });
  };

  

  const handleServiceAddress = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setCheckAsServiceAddress(true)
      setFormData({
        ...formData,
        delivery_address: address
      });

    } else {
      setHaveFinderValue(false)
      setCheckAsServiceAddress(false)
      setFormData({
        ...formData,
        delivery_address: ''
      });
    }
  };

  useEffect(() => {
    setMinimumDate();
  }, [])



  const formatDate = (date) => {
    // formats a JS date to 'yyyy-mm-dd'
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    console.log(day)

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };


  
  const handleDateChange = (date) => {
    setDate(date);
    const formattedDate = formatDate(date);
    setSelectedDate(formattedDate);


    setFormData({
      ...formData,
      ['fixedRequestedConnectionDate']: formattedDate
    });


  };

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;


  function calculateEndYear() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const endYear = currentYear + 20;
    return endYear;
  }


  const endYear = calculateEndYear();
  const endDate = `${endYear}-12-31`;


  return (
         
    

    <div id="Account" className="tabcontent">
      <section className="get-plan" style={{ marginTop: '0!important;' }}>
        <div className="container" style={{ backgroundColor: '#fff', borderTopLeftRadius: '30px', borderBottomRightRadius: '30px' }}>
          <form className="contact-form row" onSubmit={handleSubmit}>
            <div className="form-field col-lg-12">
              <b style={{ color: '#777', float: 'left' }}>Service activation Details</b>
            </div>
            <div className="form-field col-lg-12">
              <label className="label" htmlFor="inputAddress">Service Address </label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="inputAddress" value={address} disabled onChange={handleChange} />
            </div>
            {isAsap ? <div className="form-field col-lg-12 prfActivationDate">
              <label className="label" htmlFor="fixedRequestedConnectionDate">Preferred activation date <span style={{ color: '#777' }}>(DD/MM/YYYY)</span></label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="fixedRequestedConnectionDate" value="ASAP" disabled />
            </div> :

              <div className="form-field col-lg-12 prfActivationDate newDatePicker">
                <label className="label" htmlFor="mobile">Preferred activation date  </label>
                <DropdownDate
                  startDate={today}
                  endDate={endDate}
                  selectedDate={selectedDate}
                  onDateChange={handleDateChange} />
              </div>
            }
            <div className="form-field check-box-section col-lg-12">
              <label class="check-box">  As soon as possible
                <input type="checkbox" required="" name="as_soon_as_possible" value={formData.as_soon_as_possible} onChange={handleASAP} />
                <span class="tick"></span>
              </label>
            </div>

            <div className="form-field col-lg-12">
              <b style={{ color: '#777', float: 'left' }}>Delivery Details</b>
            </div>
            <div className="form-field col-lg-12">
              <label className="label" htmlFor="delivery_address">Delivery address</label>

              {checkAsServiceAddress
                ?
                <input type="text" className="input-text js-input" name="delivery_address" disabled readOnly value={formData.delivery_address} onChange={handleChange} />
                :
                <>
                  {haveFinderValue
                    ?
                    <div style={{ position: 'relative' }}>
                      <input type="text" className="input-text js-input" name="delivery_address" disabled readOnly value={formData.delivery_address} />
                      <span
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: 'transparent',
                          color: 'red',
                          border: 'none',
                          padding: '5px 10px',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setHaveFinderValue(false)
                          setFormData({
                            ...formData,
                            delivery_address: ''
                          });
                        }}
                      >
                        x
                      </span>
                    </div>
                    :
                    <AddressFinderComponent
                      addressFinderKey="UJCFN4HL6YRMT3D9K8PG"
                      inputClassName="input-text js-input"
                      id="address"
                      value={formData.delivery_address}
                      onChange={(name, value) => handleAddressFinderChange(name, value)}
                    />}
                </>
              }
            </div>
            <div className="form-field check-box-section col-lg-12">
              <label class="check-box"> Same as service address
                <input type="checkbox" required="" onChange={handleServiceAddress} />
                <span class="tick"></span>
              </label>
            </div>
            <div className="form-field col-lg-12">
              <label className="label"  htmlFor="mobile">Full name <span style={{ color: '#777' }}>(Person accepting delivery)</span></label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="person_accepting_delivery" value={formData.person_accepting_delivery} onChange={handleChange} />
            </div>
            {/* <div className="form-field col-lg-12">
              <label className="label"   htmlFor="mobile">Company Name <span style={{ color: '#777' }}>(if applicable)</span></label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="customer_company_name" value={formData.customer_company_name} onChange={handleChange} />
            </div> */}
            <div className="form-field col-lg-12">
              <div className="row">
                {/* <div className="form-field col-lg-6">
                  <input className="payment-back-btn" type="submit" value="BACK" />
                </div> */}
                <div className="form-field col-lg-12">
                  <input className="payment-submit-btn" type="submit" disabled={apiCalled} value={apiCalled ? 'Loading...' : 'CONTINUE'} onClick={buy} />
                </div>
              </div>
            </div>
          </form>
          {apiCalled && apiMessage && (
            <div className={"alert " + (apiStatus === 200 ? "alert-success" : "alert-danger")} style={{ textAlign: 'left' }}>
              <strong>{apiStatus === 200 ? "Please wait...." : ""}</strong>
              {apiMessage.delivery_address && (<strong style={{ display: 'block' }}>{apiMessage.delivery_address}</strong>)}
              {apiMessage.fixedRequestedConnectionDate && (<strong style={{ display: 'block' }}>{apiMessage.fixedRequestedConnectionDate}</strong>)}
            </div>
          )}

        </div>
      </section>
    </div>




  );
}

export default ConnectionForm;
